import { render } from "./BeritaView.vue?vue&type=template&id=4cbcc020"
import script from "./BeritaView.vue?vue&type=script&lang=js"
export * from "./BeritaView.vue?vue&type=script&lang=js"

import "./BeritaView.vue?vue&type=style&index=0&id=4cbcc020&lang=css"
import "./BeritaView.vue?vue&type=style&index=1&id=4cbcc020&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__